import strings from '../../Localization/Localization';

import {
  index,
  getFromId,
  editFromId,
  newItem
} from '../../API/AccountAnalytics';
import { form } from '../Form/accountAnalytics';
import { form as searchForm } from '../Form/Search/accountAnalytics';

import { accountAnalytics as routes } from '../Route/routes';

export const conf = {
  index: {
    id: "accountAnalytic",
    pageTitle: strings.common.homepage.accountAnalytics,
    api: index,
    onClickItem: {
      redirect: true,
      path: (id) => routes.routes.show.createPath(id)
    },

    newLink: {
      link: () => routes.routes.new.createPath(),
      auth: 'ROLE_ACCOUNTING_ACCOUNT'
    },

    searchForm: searchForm,
    computeSearch: (search) => {
      let result = {};
      if(search.title) {
        result["title"] = search.title;
      }
      if(search.number) {
        result["number"] = search.number;
      }
      return result;
    },

    availableItemDisplay:['tab'],
    itemDisplay: {
      tab: {
        headers: [
          {
            label: strings.accountAnalytic.index.tab.headers.number,
            value: "number"
          },
        ]
      }
    },

    sizing: {
      numberColumn: 2,
      formSizeMd: 12
    },

    buttons: (item) => []
  },
  show: {
    pageTitle: strings.common.homepage.accountAnalytics,
    pageTitleReturnPath: () => routes.routes.index.createPath(),
    breadcrumbIdentifier: "number",

    apiGet: getFromId,

    extendedHeader: false,

    tabs: {
      main: {
        title: strings.accountAnalytic.tab.main,
        type: 'form',
        form: form,

        onUpdateItem: (data) => {},
        onSubmit: (entity) => {},
        postEdit: {
          type: 'tab',
          tabId: 'main'
        },

        apiGet: getFromId,
        apiEdit: editFromId,

        role: ['ROLE_ACCOUNTING_ACCOUNT'],
        editable: ['ROLE_ACCOUNTING_ACCOUNT']
      }
    }
  },
  new: {
    pageTitle: strings.accountAnalytic.new.title,

    api: newItem,
    empty: {},
    form: form,
    onSubmit: (accountAnalytic) => {},
    postNew: {
      type: 'path',
      path: (id) => routes.routes.show.createPath(id)
    }
  }
}
